import { Text } from "@similarweb/ui-components/foundations";

import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import { StyledDomainChip, StyledDomainChipIcon, StyledWebsiteIcon } from "./styles";

type Props = {
    domain: string;
};

const DomainChip = ({ domain }: Props) => {
    const domainHref = siNavigator.getWebsiteAnalysisPerformanceLink({
        key: domain,
        isWWW: "*",
        duration: "3m",
        country: WORLDWIDE_COUNTRY_ID,
    });

    return (
        <StyledDomainChip
            data-automation="company-card-main-domain"
            href={domainHref}
        >
            <StyledDomainChipIcon>
                <StyledWebsiteIcon size="xs" />
            </StyledDomainChipIcon>

            <Text fontVariant="chip1TopRow">{domain}</Text>
        </StyledDomainChip>
    );
};

export default DomainChip;
